const number = value => {
  const parsed = Number(String(value ?? '').replace(/,/g, ''));
  return Number.isFinite(parsed) ? parsed : 0;
};

export const emptyMortgage = () => ({ balance: '', monthly: '', apr: '', termYears: '', termMonths: '', initialApr: '', svrApr: '', initialYears: '', initialMonths: '', svrMonthly: '' });

export function mortgageSummary(mortgages) {
  const balance = mortgages.reduce((sum, mortgage) => sum + number(mortgage.balance), 0);
  return {
    balance,
    monthly: mortgages.reduce((sum, mortgage) => sum + number(mortgage.monthly), 0),
    apr: balance > 0 ? mortgages.reduce((sum, mortgage) => sum + number(mortgage.balance) * number(mortgage.apr || mortgage.initialApr), 0) / balance : 0,
  };
}
